import { render, staticRenderFns } from "./QuoteInquiry.vue?vue&type=template&id=606bff2e&scoped=true&"
import script from "./QuoteInquiry.vue?vue&type=script&lang=js&"
export * from "./QuoteInquiry.vue?vue&type=script&lang=js&"
import style0 from "./QuoteInquiry.vue?vue&type=style&index=0&id=606bff2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606bff2e",
  null
  
)

export default component.exports